<template>
      <gmap-map
        :center="currentPlace ? currentPlace : center"
        :zoom="10"
        style="width: 100%; height: 450px"
      >
        <gmap-marker
          :key="index"
          v-for="(m, index) in markers"
          :position="m.position"
          :title="m.title"
          :icon="m.icon"
          :clickable="true"
          :draggable="true"
          @click="openInfoWindow(m)"
        ></gmap-marker>
        <gmap-info-window
          :position="infoWindow.position"
          :opened="infoWindow.open"
          @closeclick="infoWindow.open = false"
        >
          <v-btn>
            <router-link
              :to="{
              name: 'Restaurant',
              params: {
                userToken: userToken,
                restaurants: restaurants,
                restaurant: infoWindow.restaurant,
              }
            }"
            >
              {{ infoWindow.title }}
            </router-link>
          </v-btn>
          <v-btn
            :href="infoWindow.link"
            target="_blank">
            <v-icon>mdi-map-marker-distance</v-icon>
          </v-btn>
        </gmap-info-window>
      </gmap-map>
</template>

<script>


export default {
  name: "GoogleMap",

  data: () => ({
    markers: [],
    center: { lat: 46.812, lng: -71.214 },
    currentPlace: null,
    infoWindow: {
      position: { lat: 0, lng: 0 },
      open: false,
      title: "",
      restaurant: ""
    }
  }),

  props: ["restaurants", "restaurant", "userToken"],

  async created() {
    this.getGeolocations()
    this.addMarkers()
  },

  methods: {
    addMarkers: function () {
      this.restaurants.forEach(restaurant => {
        let marker = {
          restaurant: restaurant,
          title: restaurant.name,
          position: {
            lat: restaurant.location.coordinates[1],
            lng: restaurant.location.coordinates[0]
          }
        };
        if (this.restaurant !== undefined && restaurant.id === this.restaurant.id) {
          this.currentPlace = marker.position;
          marker.icon = {
            url: "http://maps.google.com/mapfiles/ms/icons/blue-dot.png",
            scaledSize: { width: 45, height: 45 }
          };
        }
        this.markers.push(marker);
      });
    },

    getGeolocations: function() {
      if (navigator.geolocation) {
        let failure, success;
        success = function(position) {
          console.log(position);
          this.currentPlace = {
            lat: position.coords.latitude,
            lng: position.coords.longitude
          }
        };
        failure = function() {
          alert('Cannot retrieve location!');
        };
        navigator.geolocation.getCurrentPosition(success, failure, {
          maximumAge: Infinity,
          timeout: 5000
        });
      }
    },

    openInfoWindow: function(item) {
      this.infoWindow.position = item.position;
      this.infoWindow.position.lat += 0.003;
      this.infoWindow.title = item.title;
      this.infoWindow.restaurant = item.restaurant;
      this.infoWindow.open = true;
      this.infoWindow.link = `https://www.google.com/maps/search/?api=1&query=${item.position.lat},${item.position.lng}`
    }

  }
}



</script>

<style scoped>

</style>
